import React from 'react';
import { Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import IntentPanel from './IntentPanel';
import '../dashboard/Dashboard.css';

const { Title, Text } = Typography;

// Intent dictionary (ADR-033): the phrases the bot understands as yes / no /
// confirm / reschedule / cancel / more, globally and per company. Module
// filters stay as they are — this widens what matches them.
const IntentDictionary = () => (
    <div className="gh-users-page">
        <div className="gh-users-filter-bar" style={{ justifyContent: 'space-between' }}>
            <Title level={4} style={{ margin: 0, whiteSpace: 'nowrap' }}>
                <CommentOutlined style={{ marginRight: 8 }} />
                Intent Dictionary
            </Title>
            <Text type="secondary" style={{ fontSize: 12 }}>
                One plain word per answer is enough on a module — punctuation, case and these synonyms are handled here.
            </Text>
        </div>
        <IntentPanel />
    </div>
);

export default IntentDictionary;
